<template>
  <section class="product-slider">
    <div class="tittle-row">
      <div class="tittle">
        <h5>PRODUCTS</h5>
        <div class="under-line"></div>
      </div>
    </div>
    <div class="pic-row">
      <div class="pic-lists">
        <ul>
          <li>
            <img :src="imgList[preImg]" v-on:click="arrowLeftClick">
            <div>
              <h5>{{nameList[preImg]}}</h5>
            </div>
          </li>
          <li>
              <img :src="imgList[currentImg]" v-on:click="routerProduct">
              <div>
                <h5>{{nameList[currentImg]}}</h5>
              </div>
          </li>
          <li>
            <img :src="imgList[nextImg]" v-on:click="arrowRightClick">
            <div>
              <h5>{{nameList[nextImg]}}</h5>
            </div>
          </li>
        </ul>
      </div>
      <a class="arrow-left" v-on:click="arrowLeftClick">
        <img src="../assets/arrow_left.svg">
      </a>
      <a class="arrow-right" v-on:click="arrowRightClick">
        <img src="../assets/arrow_right.svg">
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'slider-en',
  data () {
    return {
      preImg: 1,
      currentImg: 2,
      nextImg: 3,
      imgList: [
        '../../img/product/FoodAdditives/XanThanGum.jpg',
        '../../img/product/LacticAcid/MagnesiumLactate.jpg',
        '../../img/product/PlantEntract/SoybeanDietaryFiber.jpg',
        '../../img/product/FoodAdditives/Monoacylglyceride.jpg',
        '../../img/product/PlantEntract/Edodes.jpg'
      ],
      nameList: [
        'Xanthan gum food grade 80 mesh',
        'Magnesium lactate food grade',
        'Soybean Dietary Fiber',
        'Monoacylglyceride',
        'Edodes(Dehydrated vegetables)'
      ],
      productIndex: [
        ['foodAdditives', '05'],
        ['lacticAcid', '19'],
        ['plantEntract', '16'],
        ['foodAdditives', '24'],
        ['plantEntract', '17']
      ],
      timer: null
    }
  },
  mounted () {
    this.runTimer()
  },
  methods: {
    arrowLeftClick () {
      this.nextImg = this.currentImg
      this.currentImg = this.preImg
      this.preImg = this.preImg - 1
      if (this.preImg < 0) {
        this.preImg = 4
      }
    },
    arrowRightClick () {
      this.preImg = this.currentImg
      this.currentImg = this.nextImg
      this.nextImg = this.nextImg + 1
      if (this.nextImg > 4) {
        this.nextImg = 0
      }
    },
    runTimer () {
      this.timer = setInterval(() => {
        this.arrowRightClick()
      }, 4000)
    },
    routerProduct () {
      const url = './product?category=' + this.productIndex[this.currentImg][0] + '&&productNo=' + this.productIndex[this.currentImg][1]
      window.open(url)
    }
  }
}
</script>

<style lang="scss">
  .product-slider {
    @media(min-width: 768px) {
      width: 750px;
      margin-bottom: 20px;
    }
    @media(min-width: 992px) {
      width: 970px;
    }
    @media(min-width: 1200px) {
      width: 1170px;
    }
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 10px;
    padding-left: 15px;
    padding-right: 15px;
    .tittle-row {
      width: 100%;
      height: 60px;

      .tittle {
        float: left;

        h5 {
          font-size: 20px;
          font-weight: 600;
          line-height: 28px;
          font-family: "Lucida Grande", Helvetica, Arial, "Microsoft YaHei", FreeSans, Arimo, "Droid Sans", "wenquanyi micro hei", "Hiragino Sans GB", "Hiragino Sans GB W3", Roboto, Arial, sans-serif;
          margin-top: 0px;
          margin-bottom: 10px;
        }

        .under-line {
          width: 40px;
          height: 2px;
          background: #02328d;
          margin-bottom: 20px;
        }
      }
    }
    .pic-row {
      position: relative;
      height: 350px;
      .pic-lists {
        position: relative;
        padding-top: 25px;
        height: 300px;
        ul {
          position: relative;
          padding-inline-start: 0;
          list-style-type: none;
          li {
            position: relative;
            float: left;
            width: 33%;
            height: 350px;
            opacity: 1;
            z-index: 1;
            img {
              width: 290px;
              height: 210px;
              transform: scale(1.2);
            }
            @media (max-width: 992px) {
              width: 390px;
              left:50%;
              transform: translateX(-50%);
            }
            &:first-child {
              opacity: .4;
              transform: scale(.8);
              z-index: 0;
              @media (max-width: 992px) {
                display: none;
              }
            }
            &:last-child {
              opacity: .4;
              transform: scale(.8);
              z-index: 0;
              @media (max-width: 992px) {
                display: none;
              }
            }
          }
        }
      }
      .arrow-left {
        position: absolute;
        left: 0;
        top: 0;
        width: 10%;
        height: 100%;
        z-index: 2;
        background: -webkit-gradient(linear,left top, right top, from(rgb(0, 0, 0, .5)), to(rgb(0, 0, 0, 0)));
        opacity: .4;
        &:hover {
          opacity: .7;
        }
        img {
          position: relative;
          width: 100%;
          max-width: 100px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .arrow-right {
        position: absolute;
        right: 0;
        top: 0;
        width: 10%;
        height: 100%;
        z-index: 2;
        background: -webkit-gradient(linear,right top, left top, from(rgb(0, 0, 0, .5)), to(rgb(0, 0, 0, 0)));
        opacity: .4;
        &:hover {
          opacity: .7;
        }
        img {
          position: relative;
          width: 100%;
          max-width: 100px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
</style>
